import React from 'react';

import autoBind from 'react-autobind';
import { If, Then, Else } from 'react-if'
import DeckGL from "deck.gl";
import {WebMercatorViewport, FlyToInterpolator} from 'deck.gl';
import {GeoJsonLayer, IconLayer, TextLayer, ScatterplotLayer} from 'deck.gl'
import { _MapContext as MapContext, StaticMap, NavigationControl, Marker } from "react-map-gl";

// import other components within the same project here
import Config from "composer/Config.jsx";

import Localization from "composer/Localization.jsx"
import LocaleOverviewHotspot from "composer/views/locale/LocaleOverviewHotspot.jsx"

import ButtonGroup from '@material-ui/core/ButtonGroup';

import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Rectangle,
} from "react-google-maps";
import MarkerWithLabel from "react-google-maps/lib/components/addons/MarkerWithLabel"

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Card,
  CardContent,
  Divider,
  Typography,
  Grid,
} from '@material-ui/core';

class LocaleOverviewDialog extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      open: false,
      filePathDict: {},
      qaState: 0,
      localeData: null,
      hotspotList: [],
      map: {
        zoom: 0,
        center: {
          lat: 0,
          lon: 0
        },
        bounds:{
          ul:{
            lat: 0,
            lon: 0
          },
          br:{
            lat: 0,
            lon: 0
          }
        },
        style: Config.MBOX_STYLE(Localization.strings.getLanguage()).cartoon,
        _style: "cartoon",
        lang: "zh"
      },
    };
    autoBind(this);
  }

  close() {
    this.setState({ open: false });
    this.state.open = false;
  }

  handleClose() {
    this.close();
  }

  btnEditClicked() {
    this.handleClose();
    this.props.parent.editLocale(this.props.root.getCurrentLocale());
  }

  btnCloseClicked() {
    this.handleClose();
  }

  refresh() {
    let localeData = this.props.root.getCurrentLocale();
    this.setState({
      filePathDict: {},
      localeData: localeData,
      qaState: localeData['qa_state'],
    });
    this.state.localeData = localeData;

    let requestObj = {
      epack_id: parseInt(localeData['id']),
    };
    this.props.root.refs.API.request("get_file_path_by_epack_id", requestObj, this.getFilePathArrayOK, this.getFilePathArrayFailed);
    this.props.root.refs.API.request("get_hotspot_by_epack_id", requestObj, this.getHotspotListOK, this.getHotspotListFailed);

    let localeCenter = {lat: parseFloat(localeData.mid_lat), lng: parseFloat(localeData.mid_lon)};
    this.setState({
      viewState: {
        ...this.state.viewState,
        zoom: 15,
        longitude: localeCenter.lng,
        latitude: localeCenter.lat,
        transitionDuration: 0,
        transitionInterpolator: null
      },
      map:{
        ...this.state.map,
        style: Config.MBOX_STYLE(Localization.strings.getLanguage()).cartoon,
        _style: "cartoon",
        lang: "zh"
      }
    });
  }

  getHotspotListOK(res) {
    let hotspotList = res.body['result']['hotspot_list'];
    this.setState({ hotspotList: hotspotList });
  }

  getHotspotListFailed(err) {
    console.log("get hotspot list failed");
  }

  getFilePathArrayOK(res) {
    let dict = {};
    let pathArray = res.body['result'];
    for (let i = 0; i < pathArray.length; i++) {
      let filePath = pathArray[i];
      if (filePath['tn_path'] != "") {
        dict[filePath['id']] = filePath['tn_path'];
      }
      else {
        dict[filePath['id']] = filePath['path'];
      }
    }
    this.setState({ filePathDict: dict })
  }

  getFilePathArrayFailed(err) {
    console.log("get file path array failed");
  }

  qaStateClicked(qaState) {
    this.setState({ qaState: qaState });
    let requestObj = {
      epack_id: this.state.localeData['id'],
      qa_state: qaState,
    };
    this.props.root.refs.API.request("update_qa_state_by_epack_id", requestObj, this.updateQAstateOK, this.updateQAstateFailed);
  }

  updateQAstateOK(res){
    this.props.root.addNotification(Localization.strings.UPDATED, true);
    let localeId = res.body['result']['locale_id'];
    let qaState = res.body['result']['qa_state'];
    let localeData = this.state.localeData;
    localeData['qa_state'] = qaState;
    this.props.parent.updateLocalLocaleDataById(localeId, localeData);
  }

  updateQAstateFailed(err){
    console.log("update qa state failed");
  }

  handleKeyPress = (event) => {
    if (this.props.root.isAdminUser()) {
      let key = parseInt(event.key);
      if (key >= 0 && key <= 3) {
        this.qaStateClicked(key);
      }
    }
  }

  genBoxData(){
    var boxData = []
    boxData.push({
      'type': 'Feature',
      'color': parseInt(this.state.localeData.color).toString(16),
      'geometry': {
        'type': 'Polygon',
        'coordinates': [[
          [parseFloat(this.state.localeData.ul_lon), parseFloat(this.state.localeData.ul_lat)],
          [parseFloat(this.state.localeData.ul_lon), parseFloat(this.state.localeData.br_lat)],
          [parseFloat(this.state.localeData.br_lon), parseFloat(this.state.localeData.br_lat)],
          [parseFloat(this.state.localeData.br_lon), parseFloat(this.state.localeData.ul_lat)],
          [parseFloat(this.state.localeData.ul_lon), parseFloat(this.state.localeData.ul_lat)]
        ]]
      }
    });
    
    var boxLayers = new GeoJsonLayer({
        id: 'geojson-layer',
        data: boxData,
        lineWidthScale: 4,
        opacity: 0.4,
        filled: true,
        stroked: true,
        lineWidth: 2,
        lineWidthMinPixels: 2,
        wireframe: true,
        getLineColor: f => {
          var hex = f.color;
          while(hex.length != 6){
            hex = '0' + hex;
          }
          // convert to RGB
          return hex ? hex.match(/[0-9a-f]{2}/g).map(x => parseInt(x, 16)) : [0, 0, 0];
        },
        getFillColor: f => {
          var hex = f.color;
          while(hex.length != 6){
            hex = '0' + hex;
          }
          hex = hex + '1f';
          // convert to RGB
          return hex ? hex.match(/[0-9a-f]{2}/g).map(x => parseInt(x, 16)) : [0, 0, 0, 0];
        },
        pickable: true,
      });

      return boxLayers
  }

  genTextLayer(){
    var textData = []
    var charSet = ''

    // todo: do not show text label when adding new hotspot
    for(var i = 0; i<this.state.hotspotList.length; i++){
      textData.push({
        'color': parseInt(this.state.hotspotList[i].hotspot_detail.color).toString(16),
        //'name': ' ' + this.state.hotspotList[i].hotspot_detail.name + ' ',
        'name': this.state.hotspotList[i].hotspot_detail.name.length >= 15 ?this.state.hotspotList[i].hotspot_detail.name.substring(0, 15)+ '...' :(this.state.hotspotList[i].hotspot_detail.name),
        'coordinates': [parseFloat(this.state.hotspotList[i].hotspot_detail.lon), parseFloat(this.state.hotspotList[i].hotspot_detail.lat)]
      });
      if( this.state.hotspotList[i].hotspot_detail.name.length >= 15){
        charSet = charSet + this.state.hotspotList[i].hotspot_detail.name + '...';
      }else{
        charSet = charSet + this.state.hotspotList[i].hotspot_detail.name;
      }
    }
    var textLayers = new TextLayer({
      id: 'TextLayer',
      data: textData,
      
      /* props from TextLayer class */
      autoHighlight: false,
      background: true,
      backgroundColor: [255, 255, 255, 150], //cannot use alpha channel
      backgroundPadding: [5, 5, 5, 5],
      characterSet: charSet.split(''),
      getAlignmentBaseline: 'top',
      getAngle: 0,
      getColor: f => {
        var hex = f.color;
        while(hex.length != 6){
          hex = '0' + hex;
        }
        // convert to RGB
        return hex ? hex.match(/[0-9a-f]{2}/g).map(x => parseInt(x, 16)) : [0, 0, 0, 0];
      },
      getPosition: d => d.coordinates,
      getSize: 12,
      getText: d => d.name,
      getTextAnchor: 'middle',
      sizeScale: 1,
      pickable: true,
    });

    return textLayers;
  }

  genCircleLayer(){
    var circleData = []
    for(var i = 0; i<this.state.hotspotList.length; i++){
      circleData.push({
        'color': parseInt(this.state.hotspotList[i].hotspot_detail.color).toString(16),
        'radius': parseInt(this.state.hotspotList[i].hotspot_detail.radius),
        'centroid': [parseFloat(this.state.hotspotList[i].hotspot_detail.lon), parseFloat(this.state.hotspotList[i].hotspot_detail.lat)]
      });
    }
    
    var circleLayers = new ScatterplotLayer({
      id: 'ColumnLayer',
      data: circleData,
      extruded: false,
      getLineWidth: 20,
      diskResolution: 30,
      elevationScale: 100,
      getElevation: 0.4 * 50,
      getLineWidth: f => {
        var radius = f.radius;
        return Math.ceil(radius/11);
      },
      getLineColor: f => {
        var hex = f.color;
        while(hex.length != 6){
          hex = '0' + hex;
        }
        // convert to RGB
        return hex ? hex.match(/[0-9a-f]{2}/g).map(x => parseInt(x, 16)) : [0, 0, 0];
      },
      getFillColor: f => {
        var hex = f.color;
        while(hex.length != 6){
          hex = '0' + hex;
        }
        hex = hex + '1f';
        // convert to RGB
        return hex ? hex.match(/[0-9a-f]{2}/g).map(x => parseInt(x, 16)) : [0, 0, 0, 0];
      },
      getPosition: d => d.centroid,
      getRadius: d => d.radius,
      radiusMinPixels: 1,
      stroked: true,
      pickable: true
    });

    return circleLayers;
  }

  render() {
    let localeData = this.state.localeData;
    if (localeData != null && this.state.hotspotList != null) {
      let localeCenter = {lat: parseFloat(localeData.mid_lat), lng: parseFloat(localeData.mid_lon)};
      let localeUpperLeft = {lat: parseFloat(localeData.ul_lat), lng: parseFloat(localeData.ul_lon)};
      let localeBottomRight = {lat: parseFloat(localeData.br_lat), lng: parseFloat(localeData.br_lon)};
      let localeColor = "#" + parseInt(localeData.color).toString(16).padStart(6, '0');
      
      const initialViewState = {
        longitude: localeCenter.lng,
        latitude: localeCenter.lat,
        zoom: 15
      };

      if(Localization.strings.getLanguage() != this.state.map.lang){
        this.state.map.lang = Localization.strings.getLanguage();
        switch(this.state.map._style){
          case "mono":
            this.setState({
              map:{
                ...this.state.map,
                style: Config.MBOX_STYLE(Localization.strings.getLanguage()).mono,
                _style: "mono"
              }
            });
            this.state.map.style = Config.MBOX_STYLE(Localization.strings.getLanguage()).mono;
            this.state.map._style = "mono";
            break;
          case "satellite":
            this.setState({
              map:{
                ...this.state.map,
                style: Config.MBOX_STYLE(Localization.strings.getLanguage()).satellite,
                _style: "satellite"
              }
            });
            this.state.map.style = Config.MBOX_STYLE(Localization.strings.getLanguage()).satellite;
            this.state.map._style = "satellite";
            break;
          case "cartoon":
            this.setState({
              map:{
                ...this.state.map,
                style: Config.MBOX_STYLE(Localization.strings.getLanguage()).cartoon,
                _style: "cartoon"
              }
            });
            this.state.map.style = Config.MBOX_STYLE(Localization.strings.getLanguage()).cartoon;
            this.state.map._style = "cartoon";
            break;
        }
      }

      const { viewState, map } = this.state;
      const boxLayers = this.genBoxData();
      const textLayers = this.genTextLayer();
      const circleLayers = this.genCircleLayer();

      let editLocaleEnabled = (this.props.root.isAdminUser() || (this.props.root.getSameSchoolEdit() && localeData['school_id'] == this.props.root.getMySchoolId()) || this.props.root.getMyUserId() == localeData['user_id']);
      
      //If the description is too long, break down the word
      let paragraph = "";
      for (var i=0;i<localeData['description'].length;i++){
        if(i%80 == 0 && window.screen.width >= 1024){
          paragraph = paragraph + "\n" ;
        }

        if(i%40 == 0 && window.screen.width < 1024){
          paragraph = paragraph + "\n" ;
        }
        paragraph = paragraph + localeData['description'][i];
      }
      //

      return (
        <div>
          <Dialog
            fullWidth={true}
            maxWidth={'lg'}
            open={this.state.open}
            onClose={this.handleClose}
            onKeyPress={this.handleKeyPress}
          >
            <DialogTitle disableTypography={true}>
              <Typography variant="h6" style={{width:window.screen.width>=1024?"55%":"20%"}}>
              {Localization.strings.OVERVIEW + " - " + localeData['name']}
              </Typography>
              <If condition={this.props.root.isAdminUser()}>
                <Then>
                  <span style={{position:'absolute', top:16, right:16}}>
                  <Button color={this.state.qaState == 0? "secondary":"default"} onClick={() => this.qaStateClicked(0)}>Unchecked (0)</Button>
                  <Button color={this.state.qaState == 1? "secondary":"default"} onClick={() => this.qaStateClicked(1)}>Checked (1)</Button>
                  <Button color={this.state.qaState == 2? "secondary":"default"} onClick={() => this.qaStateClicked(2)}>Minor (2)</Button>
                  <Button color={this.state.qaState == 3? "secondary":"default"} onClick={() => this.qaStateClicked(3)}>Major (3)</Button>
                </span>
                </Then>
              </If>
            </DialogTitle>
            <DialogContent dividers>
                <DialogContentText style={{maxWidth:"95%"}}>
                  {Localization.strings.DESCRIPTION + ": " }
                  {paragraph}
                </DialogContentText>
              <Grid container>
                <Grid item xs={12} sm={6}>
                  <div style={{position:"relative", height:'70vh'}}>
                    <DeckGL 
                      initialViewState={initialViewState} 
                      // viewState={viewState}
                      ContextProvider={MapContext.Provider}
                      controller={true} height={this.state.height} 
                      top="50px" position="relative" 
                      layers={[boxLayers, circleLayers, textLayers]}
                      // onViewStateChange={(viewState =>{
                      //   this.setState({
                      //     viewState: {
                      //       ...this.state.viewState,
                      //       zoom: viewState.viewState.zoom,
                      //       longitude: viewState.viewState.longitude,
                      //       latitude: viewState.viewState.latitude,
                      //       transitionDuration: 0,
                      //       transitionInterpolator: null
                      //     }
                      //   });
                      // })}
                    >
                  
                        <StaticMap mapStyle={map.style} mapboxApiAccessToken={Config.MBOX_KEY()} attributionControl={false}/>
                        <ButtonGroup style={{top:10, left:10, position:"relative"}} size="small" variant="contained" color="primary" aria-label="contained primary button group">
                          <Button color={this.state.map._style=="mono"? "secondary":"primary"} onClick={
                            () => {
                              this.setState({
                                map:{
                                  ...this.state.map,
                                  style: Config.MBOX_STYLE(Localization.strings.getLanguage()).mono,
                                  _style: "mono"
                                }
                              });
                              this.state.map.style = Config.MBOX_STYLE(Localization.strings.getLanguage()).mono;
                              this.state.map._style = "mono";
                            }
                          }>MONO</Button>
                          <Button color={this.state.map._style=="satellite"? "secondary":"primary"} onClick={
                            () => {
                              this.setState({
                                map:{
                                  ...this.state.map,
                                  style: Config.MBOX_STYLE(Localization.strings.getLanguage()).satellite,
                                  _style: "satellite"
                                }
                              });
                              this.state.map.style = Config.MBOX_STYLE(Localization.strings.getLanguage()).satellite;
                              this.state.map._style = "satellite";
                            }
                          }>SATELLITE</Button>
                          <Button color={this.state.map._style=="cartoon"? "secondary":"primary"} onClick={
                            () => {
                              this.setState({
                                map:{
                                  ...this.state.map,
                                  style: Config.MBOX_STYLE(Localization.strings.getLanguage()).cartoon,
                                  _style: "cartoon"
                                }
                              });
                              this.state.map.style = Config.MBOX_STYLE(Localization.strings.getLanguage()).cartoon;
                              this.state.map._style = "cartoon";
                            }
                          }>VECTOR</Button>
                        </ButtonGroup>
                        <NavigationControl style={{top:10, right:10}} showCompass={false}/>
                    </DeckGL>
                  </div>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <If condition={this.state.hotspotList.length == 0}>
                    <Then>
                    <Divider variant="middle"/>
                      <Card elevation={0}>
                        <CardContent>
                          Click the EDIT button to start creating hotspot.
                        </CardContent>
                      </Card>
                    </Then>
                  </If>
                  {this.state.hotspotList.map( (row, i) => {
                    console.log("hotspotList["+i+"] : " + JSON.stringify(this.state.hotspotList[i].hotspot_detail));
                    return (
                      <div key={i}> 
                        <LocaleOverviewHotspot root={this.props.root} parent={this} hotspotData={row['hotspot_detail'] }/>
                      </div>
                    );
                  })}
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions style={{padding:'16px 24px'}}>
              <Button disabled={!editLocaleEnabled} onClick={this.btnEditClicked}
              color="secondary"
              variant="contained"
              >{Localization.strings.EDIT}</Button>
              <Button
                onClick={this.btnCloseClicked}
                color="primary"
                variant="contained"
              >
                {Localization.strings.CLOSE}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )
    }
    else {
      return (
        <div/>
      )
    }
  }
}

export default LocaleOverviewDialog;
